import React from "react";
// import * as actions from '../Actions';
import './WeekSlider.css';

export default function ShareIcon({ eleRef,tool }) {
    return (
        <div className="shareIcon">
            <div className="share-container" onClick={(e) => eleRef.shareIcon(e)}>
                <span data-icon-font="&#xe027;" className="icon L14_9e share-icon"></span>
                <div className="social_action_names share-text">Share</div>
            </div>
            <div className="sharing-options">
                <ul className="left">
                    <li className="whatsapp-share left" onClick={(e) => eleRef.shareTemplate(eleRef.state.clickwedWeek,'whatsapp',eleRef.state.image)}>
                        <span className="M16_61 social-share" id="whatsapp">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                        </span>
                    </li>
                    <li className="facebook-share left" onClick={(e) => eleRef.shareTemplate(eleRef.state.clickwedWeek,'facebook',eleRef.state.image)}>
                        <span className="M16_61 social-share" id="facebook">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                        </span>
                    </li>
                    <li className="twitter-share left" onClick={(e) => eleRef.shareTemplate(eleRef.state.clickwedWeek,'twitter',eleRef.state.image)}>
                        <span className="M16_61 social-share" id="twitter">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                        </span>
                    </li>
                    <li className="twitter-share left" onClick={(e) => eleRef.shareTemplate(eleRef.state.clickwedWeek,'pintrest',eleRef.state.image)}>
                        <span className="M16_61 social-share" id="pintrest">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    );
}
